import { Component, Input } from '@angular/core';
import { TeamSeason } from 'src/app/model/team-season';

@Component({
  selector: 'mobile-navigation',
  templateUrl: 'mobile-navigation.html',
  styleUrls: ["mobile-navigation.css"]
})

export class MobileNavigationComponent {
  @Input() teamSeasons: Map<String, TeamSeason> = new Map<String, TeamSeason>();
  hamburgerIconSrc: string = "assets/img/hamburger_icon.png";
  showItems: boolean = false;

  constructor() { }

  private onMouseOver(): void {
    this.hamburgerIconSrc = "/assets/img/hamburger_icon_hover.png";
  }

  private onMouseOut(): void {
    this.hamburgerIconSrc = "/assets/img/hamburger_icon.png";
  }

  private toggleMobileNavigation() {
    this.showItems = !this.showItems;
  }

  private closeMobileNavigation() {
    this.showItems = false;
  }
}
